/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Auth}
 */
// @ts-ignore
export function createAuthFromDiscriminatorValue(parseNode) {
    return deserializeIntoAuth;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BaseClientRepresentation}
 */
// @ts-ignore
export function createBaseClientRepresentationFromDiscriminatorValue(parseNode) {
    if (!parseNode)
        throw new Error("parseNode cannot be undefined");
    const mappingValueNode = parseNode?.getChildNode("protocol");
    if (mappingValueNode) {
        const mappingValue = mappingValueNode.getStringValue();
        if (mappingValue) {
            switch (mappingValue) {
                case "openid-connect":
                    return deserializeIntoOIDCClientRepresentation;
                case "saml":
                    return deserializeIntoSAMLClientRepresentation;
            }
        }
    }
    return deserializeIntoBaseClientRepresentation;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OIDCClientRepresentation}
 */
// @ts-ignore
export function createOIDCClientRepresentationFromDiscriminatorValue(parseNode) {
    return deserializeIntoOIDCClientRepresentation;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SAMLClientRepresentation}
 */
// @ts-ignore
export function createSAMLClientRepresentationFromDiscriminatorValue(parseNode) {
    return deserializeIntoSAMLClientRepresentation;
}
/**
 * The deserialization information for the current model
 * @param Auth The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuth(auth = {}) {
    return {
        "certificate": n => { auth.certificate = n.getStringValue(); },
        "method": n => { auth.method = n.getStringValue(); },
        "secret": n => { auth.secret = n.getStringValue(); },
    };
}
/**
 * The deserialization information for the current model
 * @param BaseClientRepresentation The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBaseClientRepresentation(baseClientRepresentation = {}) {
    return {
        "appUrl": n => { baseClientRepresentation.appUrl = n.getStringValue(); },
        "clientId": n => { baseClientRepresentation.clientId = n.getStringValue(); },
        "description": n => { baseClientRepresentation.description = n.getStringValue(); },
        "displayName": n => { baseClientRepresentation.displayName = n.getStringValue(); },
        "enabled": n => { baseClientRepresentation.enabled = n.getBooleanValue(); },
        "protocol": n => { baseClientRepresentation.protocol = n.getStringValue(); },
        "redirectUris": n => { baseClientRepresentation.redirectUris = n.getCollectionOfPrimitiveValues(); },
        "roles": n => { baseClientRepresentation.roles = n.getCollectionOfPrimitiveValues(); },
        "uuid": n => { baseClientRepresentation.uuid = n.getStringValue(); },
    };
}
/**
 * The deserialization information for the current model
 * @param OIDCClientRepresentation The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOIDCClientRepresentation(oIDCClientRepresentation = {}) {
    return {
        ...deserializeIntoBaseClientRepresentation(oIDCClientRepresentation),
        "auth": n => { oIDCClientRepresentation.auth = n.getObjectValue(createAuthFromDiscriminatorValue); },
        "loginFlows": n => { oIDCClientRepresentation.loginFlows = n.getCollectionOfEnumValues(FlowObject); },
        "serviceAccountRoles": n => { oIDCClientRepresentation.serviceAccountRoles = n.getCollectionOfPrimitiveValues(); },
        "webOrigins": n => { oIDCClientRepresentation.webOrigins = n.getCollectionOfPrimitiveValues(); },
    };
}
/**
 * The deserialization information for the current model
 * @param SAMLClientRepresentation The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSAMLClientRepresentation(sAMLClientRepresentation = {}) {
    return {
        ...deserializeIntoBaseClientRepresentation(sAMLClientRepresentation),
        "allowEcpFlow": n => { sAMLClientRepresentation.allowEcpFlow = n.getBooleanValue(); },
        "clientSignatureRequired": n => { sAMLClientRepresentation.clientSignatureRequired = n.getBooleanValue(); },
        "forceNameIdFormat": n => { sAMLClientRepresentation.forceNameIdFormat = n.getBooleanValue(); },
        "forcePostBinding": n => { sAMLClientRepresentation.forcePostBinding = n.getBooleanValue(); },
        "frontChannelLogout": n => { sAMLClientRepresentation.frontChannelLogout = n.getBooleanValue(); },
        "includeAuthnStatement": n => { sAMLClientRepresentation.includeAuthnStatement = n.getBooleanValue(); },
        "nameIdFormat": n => { sAMLClientRepresentation.nameIdFormat = n.getStringValue(); },
        "signAssertions": n => { sAMLClientRepresentation.signAssertions = n.getBooleanValue(); },
        "signatureAlgorithm": n => { sAMLClientRepresentation.signatureAlgorithm = n.getStringValue(); },
        "signatureCanonicalizationMethod": n => { sAMLClientRepresentation.signatureCanonicalizationMethod = n.getStringValue(); },
        "signDocuments": n => { sAMLClientRepresentation.signDocuments = n.getBooleanValue(); },
        "signingCertificate": n => { sAMLClientRepresentation.signingCertificate = n.getStringValue(); },
    };
}
/**
 * Serializes information the current object
 * @param Auth The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuth(writer, auth = {}, isSerializingDerivedType = false) {
    if (!auth || isSerializingDerivedType) {
        return;
    }
    writer.writeStringValue("certificate", auth.certificate);
    writer.writeStringValue("method", auth.method);
    writer.writeStringValue("secret", auth.secret);
    writer.writeAdditionalData(auth.additionalData);
}
/**
 * Serializes information the current object
 * @param BaseClientRepresentation The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBaseClientRepresentation(writer, baseClientRepresentation = {}, isSerializingDerivedType = false) {
    if (!baseClientRepresentation || isSerializingDerivedType) {
        return;
    }
    writer.writeStringValue("appUrl", baseClientRepresentation.appUrl);
    writer.writeStringValue("clientId", baseClientRepresentation.clientId);
    writer.writeStringValue("description", baseClientRepresentation.description);
    writer.writeStringValue("displayName", baseClientRepresentation.displayName);
    writer.writeBooleanValue("enabled", baseClientRepresentation.enabled);
    writer.writeStringValue("protocol", baseClientRepresentation.protocol);
    writer.writeCollectionOfPrimitiveValues("redirectUris", baseClientRepresentation.redirectUris);
    writer.writeCollectionOfPrimitiveValues("roles", baseClientRepresentation.roles);
    writer.writeAdditionalData(baseClientRepresentation.additionalData);
    switch (baseClientRepresentation.protocol) {
        case "openid-connect":
            serializeOIDCClientRepresentation(writer, baseClientRepresentation, true);
            break;
        case "saml":
            serializeSAMLClientRepresentation(writer, baseClientRepresentation, true);
            break;
    }
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OIDCClientRepresentation The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOIDCClientRepresentation(writer, oIDCClientRepresentation = {}, isSerializingDerivedType = false) {
    if (!oIDCClientRepresentation || isSerializingDerivedType) {
        return;
    }
    serializeBaseClientRepresentation(writer, oIDCClientRepresentation, isSerializingDerivedType);
    writer.writeObjectValue("auth", oIDCClientRepresentation.auth, serializeAuth);
    if (oIDCClientRepresentation.loginFlows)
        writer.writeCollectionOfEnumValues("loginFlows", oIDCClientRepresentation.loginFlows);
    writer.writeCollectionOfPrimitiveValues("serviceAccountRoles", oIDCClientRepresentation.serviceAccountRoles);
    writer.writeCollectionOfPrimitiveValues("webOrigins", oIDCClientRepresentation.webOrigins);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SAMLClientRepresentation The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSAMLClientRepresentation(writer, sAMLClientRepresentation = {}, isSerializingDerivedType = false) {
    if (!sAMLClientRepresentation || isSerializingDerivedType) {
        return;
    }
    serializeBaseClientRepresentation(writer, sAMLClientRepresentation, isSerializingDerivedType);
    writer.writeBooleanValue("allowEcpFlow", sAMLClientRepresentation.allowEcpFlow);
    writer.writeBooleanValue("clientSignatureRequired", sAMLClientRepresentation.clientSignatureRequired);
    writer.writeBooleanValue("forceNameIdFormat", sAMLClientRepresentation.forceNameIdFormat);
    writer.writeBooleanValue("forcePostBinding", sAMLClientRepresentation.forcePostBinding);
    writer.writeBooleanValue("frontChannelLogout", sAMLClientRepresentation.frontChannelLogout);
    writer.writeBooleanValue("includeAuthnStatement", sAMLClientRepresentation.includeAuthnStatement);
    writer.writeStringValue("nameIdFormat", sAMLClientRepresentation.nameIdFormat);
    writer.writeBooleanValue("signAssertions", sAMLClientRepresentation.signAssertions);
    writer.writeStringValue("signatureAlgorithm", sAMLClientRepresentation.signatureAlgorithm);
    writer.writeStringValue("signatureCanonicalizationMethod", sAMLClientRepresentation.signatureCanonicalizationMethod);
    writer.writeBooleanValue("signDocuments", sAMLClientRepresentation.signDocuments);
    writer.writeStringValue("signingCertificate", sAMLClientRepresentation.signingCertificate);
}
export const FlowObject = {
    STANDARD: "STANDARD",
    IMPLICIT: "IMPLICIT",
    DIRECT_GRANT: "DIRECT_GRANT",
    SERVICE_ACCOUNT: "SERVICE_ACCOUNT",
    TOKEN_EXCHANGE: "TOKEN_EXCHANGE",
    DEVICE: "DEVICE",
    CIBA: "CIBA",
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map